import { Controller } from "@hotwired/stimulus"

// Header-level editor mode toggle (icon-only).
//
// This is intentionally decoupled from the Milkdown controller's DOM subtree.
// It communicates via window events:
// - dispatch: wittle:milkdown:setMode { detail: { mode: "rich" | "markdown" } }
// - listen:   wittle:milkdown:modeChanged { detail: { mode: "rich" | "markdown" } }
export default class extends Controller {
  static targets = ["option"]

  connect() {
    this._onModeChanged = (e) => {
      const mode = e?.detail?.mode
      if (!mode) return
      this._apply(mode)
    }
    window.addEventListener("wittle:milkdown:modeChanged", this._onModeChanged)

    // Initial state from URL to avoid flashing the wrong active button.
    this._apply(this._modeFromUrl() || "rich")
  }

  disconnect() {
    if (this._onModeChanged) {
      window.removeEventListener("wittle:milkdown:modeChanged", this._onModeChanged)
      this._onModeChanged = null
    }
  }

  choose(event) {
    event?.preventDefault?.()
    const mode = event?.currentTarget?.dataset?.mode
    if (!mode) return

    try {
      window.dispatchEvent(new CustomEvent("wittle:milkdown:setMode", { detail: { mode } }))
    } catch (_) {
      // ignore
    }
  }

  _modeFromUrl() {
    try {
      const url = new URL(window.location.href)
      return url.searchParams.get("editor") === "markdown" ? "markdown" : "rich"
    } catch {
      return null
    }
  }

  _apply(mode) {
    const current = mode === "markdown" ? "markdown" : "rich"
    if (!this.hasOptionTarget) return
    this.optionTargets.forEach((el) => {
      const active = el.dataset.mode === current
      el.classList.toggle("active", active)
      el.setAttribute("aria-pressed", active ? "true" : "false")
    })
  }
}


